import React from "react";
import MenuButton from "../components/MenuButton";

const NavMenu = (props) => (
  <div>
    <MenuButton menuList={props.menuList} />
    {/* <ReactJkMusicPlayer {...props.musicParams} /> */}
  </div>
);

export default NavMenu;
